"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeToolRepo = exports.ToolRepository = void 0;
const ObservableEntity_1 = require("./ObservableEntity");
const Tool_1 = require("./Tool");
class ToolRepository extends ObservableEntity_1.ObservableEntity {
}
exports.ToolRepository = ToolRepository;
function makeToolRepo() {
    return new ToolRepositoryImp();
}
exports.makeToolRepo = makeToolRepo;
class ToolRepositoryImp extends ToolRepository {
    constructor() {
        super(...arguments);
        this.toolLookup = new Map();
    }
    get allTools() {
        return Array.from(this.toolLookup.values());
    }
    setDefaultToolActive() {
        if (this._defaultToolType !== undefined) {
            this.triggerTool(this._defaultToolType);
        }
        else {
            console.warn(`[ToolRepository] No default tools has been specified`);
        }
    }
    setupToolsFromData(toolDatas) {
        toolDatas.forEach((toolData) => {
            const type = toolData.type;
            if (this.toolLookup.has(type)) {
                console.warn(`[ToolRepository] A tool with the ID ${toolData.type} already exists. Replacing`);
            }
            const tool = Tool_1.makeTool(toolData);
            this.toolLookup.set(type, tool);
            if (toolData.isDefault) {
                if (this._defaultToolType) {
                    console.warn(`[ToolRepository] More than one tools is marked as default. Replacing`);
                }
                this._defaultToolType = type;
            }
        });
        if (!this._defaultToolType) {
            console.warn(`[ToolRepository] No default tools was specified. Defaulting to the first tool in the list`);
            this._defaultToolType = Array.from(this.toolLookup.keys())[0];
        }
        if (this._defaultToolType) {
            this.triggerTool(this._defaultToolType);
        }
    }
    getTool(type) {
        return this.toolLookup.get(type);
    }
    getToolForHotkey(hotkey) {
        let tool;
        this.allTools.forEach((t) => {
            if (t.isMyHotkey(hotkey)) {
                tool = t;
            }
        });
        return tool;
    }
    get activeTool() {
        if (!this._activeToolType)
            return undefined;
        return this.getTool(this._activeToolType);
    }
    triggerTool(type) {
        if (this._activeToolType === type)
            return;
        const newActiveTool = this.toolLookup.get(type);
        if (!newActiveTool) {
            console.warn(`[ToolRepository] Unable to find tool ${type}`);
            return;
        }
        if (newActiveTool.isAction) {
            newActiveTool.triggerActions();
            return;
        }
        if (newActiveTool.state === Tool_1.ToolState.DISABLED) {
            return;
        }
        if (newActiveTool.state === Tool_1.ToolState.HIDDEN) {
            return;
        }
        this.toolLookup.forEach((tool) => {
            if (tool.type === type) {
                this._activeToolType = type;
                tool.state = Tool_1.ToolState.ACTIVE;
            }
            else if (tool.state === Tool_1.ToolState.ACTIVE) {
                tool.state = Tool_1.ToolState.ENABLED;
            }
        });
        this.notify();
    }
    toggleToolVisibility(type) {
        const tool = this.getTool(type);
        if (!tool) {
            console.warn(`[ToolRepository] Unable to find tool to toggle: ${type}`);
            return;
        }
        if (tool.type === this._defaultToolType) {
            console.warn(`[ToolRepository] The default tool's visibility cannot be toggled`);
            return;
        }
        if (tool.state === Tool_1.ToolState.HIDDEN) {
            tool.state = Tool_1.ToolState.ENABLED;
        }
        else {
            if (tool.state === Tool_1.ToolState.ACTIVE) {
                this.setDefaultToolActive();
            }
            tool.state = Tool_1.ToolState.HIDDEN;
        }
    }
}
